import styled from '@emotion/styled';
import { getStateKeyByValue } from '@utils';
import { FormState, TFormState, TSkillType } from '@definitions';
import { useAppTranslation } from '@hooks';
import { CardForm, CardFormActionType } from '@views/shared/form';
import {
  Checkbox,
  colors,
  IAvailableIcons,
  Icon,
  ITagProps,
  Row,
  Tag,
  Text,
} from 'common-components';

const DraftRibbon = styled(Row)`
  position: absolute;
  top: -4px;
  right: -76px;
  width: 186px;
  height: 42px;
  transform: rotate(45deg);
  background-color: ${colors.gray600};
  align-items: flex-end;
  justify-content: center;
`;

type FormManagementCardPropsType = {
  form: {
    idForm: string
    name: string
    skill: TSkillType
    updateDate: string
    state: TFormState
    nbReviewers: number
  }
  tags?: (ITagProps & { label: string; icon?: IAvailableIcons })[]
  canSelect?: boolean
  onFormOpen?: (idForm: string) => void
  onFormCopy?: (idForm: string) => void
  onFormDelete?: (idForm: string) => void
};

const ManagementCardForm = ({
  form,
  tags = [],
  onFormOpen,
  onFormCopy,
  onFormDelete,
  canSelect,
}: FormManagementCardPropsType) => {
  const { translate } = useAppTranslation();
  const isDraft = form?.state === getStateKeyByValue(FormState, 'creating');
  const isArchived = form?.state === getStateKeyByValue(FormState, 'archived');

  const actions: CardFormActionType[] = [];
  if (!isArchived && onFormOpen) {
    actions.push({ icon: 'LinkExternal02', onClick: () => onFormOpen(form.idForm) });
  }
  if (!isArchived && onFormCopy) {
    actions.push({ icon: 'Copy01', onClick: () => onFormCopy(form.idForm) });
  }
  if (!isArchived && onFormDelete) {
    actions.push({ icon: 'Trash01', onClick: () => onFormDelete(form.idForm) });
  }

  return (
    <CardForm
      form={form}
      actions={actions}
      archived={isArchived}
      header={
        canSelect && (
          <Row align="middle" style={{ height: 24 }}>
            <Checkbox key={form.idForm} value={form.idForm} />
          </Row>
        )
      }
      decoration={
        isDraft && (
          <DraftRibbon>
            <Text size="xs" color={colors.white} style={{ fontWeight: 500 }}>
              {translate('form.draftLabel')}
            </Text>
          </DraftRibbon>
        )
      }
    >
      {tags.map((tag) => (
        <Tag key={tag.label} color={colors.gray700} {...tag}>
          {tag.icon && <Icon icon={tag.icon} />}
          {tag.label}
        </Tag>
      ))}
    </CardForm>
  );
};

export default ManagementCardForm;
